import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";
import {withApollo} from "react-apollo";

import "../style.css";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class ShowPasswordModal extends React.Component {
  constructor(props) {
    super(props);

    this.timeout = null;
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.props.onViewPasswordClose();

      clearTimeout(this.timeout);
      this.timeout = null;
    }, 5000);
  } 

  onConfirm() {
    this.props.onViewPasswordClose()
    clearTimeout(this.timeout);
    this.timeout = null;
  }
   
  render(){
      return(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={`${this.props.user.username}`}
            showCancel={false}
            showConfirm={true}
            onConfirm={() => this.onConfirm()}
            confirmBtnText="Done"
            >
              {this.props.password}
          </SweetAlert>
      )
  }
}

export default  withStyles(sweetAlertStyle)(ShowPasswordModal);


// WEBPACK FOOTER //
// ./src/views/users/components/ShowPasswordModal.js